const initState =
{

}

const searchReducer = (state = initState, action) => {
    return state;
}
export default searchReducer